import React from 'react'

export default () => {
    return {
        'react_obj': <span style={{color:"red"}}>
                Unknown Command
            </span>
    }
}